module.exports = __webpack_public_path__ + "5a06b5939f5948e3764d1f64c98e2eae.MP3";